export const API_STATUS = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
};
